import { memo } from "react";

function APTDeliveryStopMarker({ stopNo, backgroundColor, textColor }) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -3;
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.5 7C29.5 10.5899 26.5899 13.5 23 13.5C19.4101 13.5 16.5 10.5899 16.5 7C16.5 3.41015 19.4101 0.5 23 0.5C26.5899 0.5 29.5 3.41015 29.5 7ZM14.5 8.7002C14.5 12.1218 17.1438 14.9259 20.5 15.1813V24.7002C20.5 26.6332 18.933 28.2002 17 28.2002H4C2.067 28.2002 0.5 26.6332 0.5 24.7002V11.7002C0.5 9.7672 2.067 8.2002 4 8.2002H14.519C14.5064 8.36529 14.5 8.53203 14.5 8.7002Z"
        fill={backgroundColor}
        stroke={textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24657 15.6514C7.17387 16.0964 7.41747 16.9417 7.76227 17.727C8.07987 18.4504 8.54787 19.1391 9.17677 19.7682L9.21717 19.8089C10.5321 21.1233 11.7629 21.761 13.3887 21.7668C13.4859 21.6862 14.0244 21.259 14.2397 20.703C14.2351 20.6997 14.2189 20.649 14.2015 20.6082C14.1252 20.6082 13.3887 20.3323 13.156 20.3119C13.156 20.3119 12.9229 20.7938 12.585 21.053C12.247 21.3121 11.3192 20.8938 10.8234 20.531C10.4045 20.2268 9.90967 19.8745 9.50737 19.4789C9.10837 19.0729 8.83477 18.6691 8.52597 18.246C8.32237 17.9672 7.89907 17.3138 7.98687 16.7543C8.07467 16.1948 8.91577 15.8886 8.91417 15.8633C8.73127 15.1834 8.73957 15.3465 8.52597 14.7489C8.49027 14.736 8.44497 14.7252 8.41297 14.7252C8.01787 14.9321 7.31917 15.2064 7.24657 15.6514ZM13.8897 23C11.9726 23 9.99087 22.1171 8.45177 20.5786L8.42127 20.5458C6.82537 18.9367 5.95527 16.9156 6.00177 14.9664L6.00517 14.8226L6.09427 14.7099C6.23207 14.5347 6.36807 14.3801 6.51107 14.2376C7.03327 13.7155 7.64717 13.316 8.33597 13.0491C8.41957 13.0168 8.51427 13 8.61667 13C8.84877 13 9.37057 13.118 9.50397 13.4834C9.73907 14.136 10.0357 14.9875 10.2514 15.802C10.3112 16.0306 10.2527 16.5829 9.93317 16.7843L9.17207 17.2669C9.17897 17.2729 9.17547 17.3917 9.27457 17.5273C9.56987 17.932 9.91217 18.3323 10.291 18.718C10.6729 19.093 11.072 19.4331 11.4732 19.7249C11.5516 19.7822 11.6398 19.8153 11.7113 19.8153L11.9748 19.4477L12.2171 19.0659C12.4281 18.7387 12.9563 18.7292 13.0157 18.7292C13.0773 18.7292 13.132 18.7348 13.1828 18.746C14.1855 18.9699 14.7822 19.1623 15.5476 19.5093C15.8877 19.6625 16.1025 20.2794 15.9501 20.6664C15.6849 21.353 15.2854 21.9669 14.7645 22.489C14.6168 22.6358 14.4575 22.7762 14.2896 22.907L14.1773 22.9953L13.8897 23Z"
        fill={textColor}
      />
      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={21 + shiftLeft} y={10}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(APTDeliveryStopMarker);
